import React, { useState, useEffect } from 'react';
import MinigameQRScanner from '../components/MinigameQrScanner';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { formatCurrency } from '../utils/formatters';

const MinigamesPage = () => {
  // Get user from session storage instead of context
  const userString = sessionStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : null;
  
  const [minigames, setMinigames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedMinigame, setSelectedMinigame] = useState(null);
  const [scanningMode, setScanningMode] = useState(false);
  
  useEffect(() => {
    const fetchMinigames = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/api/minigames`);
        setMinigames(response.data.filter(game => game.active));
        setLoading(false);
      } catch (err) {
        console.error('Error fetching minigames:', err);
        setError('Failed to load minigames');
        setLoading(false);
      }
    };
    
    fetchMinigames();
  }, []);
  
  const handleScanSuccess = (data) => {
    console.log('Scan successful:', data);
    // Reset scanning mode after success
    if (data.completed) {
      setScanningMode(false);
      setSelectedMinigame(null);
    }
  };
  
  const handleScanError = (error) => {
    console.error('Scan error:', error);
    setError(error.message || 'Error scanning QR code');
  };
  
  const startScanning = (minigame) => {
    setSelectedMinigame(minigame);
    setScanningMode(true);
  };
  
  const cancelScanning = () => {
    setScanningMode(false);
    setSelectedMinigame(null);
  };
  
  if (loading) {
    return <div className="loading">Loading minigames...</div>;
  }
  
  return (
    <div className="minigames-page">
      <h1>Minigames</h1>
      
      {error && <div className="error-message">{error}</div>}
      
      {scanningMode && selectedMinigame ? (
        <div className="scanner-container">
          <h2>Scan QR Code for {selectedMinigame.name}</h2>
          <MinigameQRScanner 
            userId={user?.id}
            minigameId={selectedMinigame.id}
            onSuccess={handleScanSuccess}
            onError={handleScanError}
          />
          <button className="cancel-button" onClick={cancelScanning}>
            Cancel
          </button>
        </div>
      ) : (
        <>
          <div className="scan-any-minigame">
            <button 
              className="scan-button"
              onClick={() => setScanningMode(true)}
            >
              Scan Any Minigame QR Code
            </button>
          </div>
          
          <div className="minigames-list">
            {minigames.length === 0 ? (
              <p>No minigames available at this time.</p>
            ) : (
              minigames.map(minigame => (
                <div key={minigame.id} className="minigame-card">
                  <div className="minigame-icon">
                    🎮
                  </div>
                  <div className="minigame-details">
                    <h3>{minigame.name}</h3>
                    <p>{minigame.description}</p>
                    <p className="minigame-cost">Cost: {formatCurrency(minigame.cost)}</p>
                  </div>
                  <button 
                    className="play-button"
                    onClick={() => startScanning(minigame)}
                  >
                    Play
                  </button>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MinigamesPage; 